import React from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import uniqBy from 'lodash/uniqBy';
import { Autocomplete } from 'components/standalone';
import {
  SupervisorOption,
  UserRoleRegion,
} from '../containers/useSubDivisionContainer';

interface SubDivisionSupervisorsSectionProps {
  supervisors: UserRoleRegion[];
  builderSupervisors: UserRoleRegion[];
  selectedSupervisors: SupervisorOption[];
  selectedBuilderSupervisors: SupervisorOption[];
  onSupervisorsChange?: (supervisors: SupervisorOption[]) => void;
  onBuilderSupervisorsChange?: (supervisors: SupervisorOption[]) => void;
  supervisorError?: string;
  disabled?: boolean;
  loading?: boolean;
}

export const SubDivisionSupervisorsSection: React.FC<SubDivisionSupervisorsSectionProps> =
  ({
    supervisors,
    builderSupervisors,
    selectedSupervisors,
    selectedBuilderSupervisors,
    onSupervisorsChange,
    onBuilderSupervisorsChange,
    supervisorError,
    disabled = false,
    loading = false,
  }) => {
    const classes = useStyles();

    const supervisorOptions = supervisors.map(item => ({
      name: `${item.firstName} ${item.lastName}`,
      id: item.id,
    }));

    const builderSupervisorOptions = builderSupervisors.map(item => ({
      name: `${item.firstName} ${item.lastName}`,
      id: item.id,
    }));

    return (
      <Box className={classes.container}>
        <Autocomplete<SupervisorOption>
          multiple
          fullWidth
          options={supervisorOptions}
          value={selectedSupervisors}
          onChange={value => {
            const uniqValues = uniqBy(value, item => item.id);
            onSupervisorsChange?.(uniqValues);
          }}
          getOptionLabel={option => (option ? option.name : '')}
          variant="standard"
          label="Supervisors"
          helperText={supervisorError}
          error={supervisorError}
          loading={loading}
          disabled={disabled}
        />
        <Autocomplete<SupervisorOption>
          multiple
          fullWidth
          options={builderSupervisorOptions}
          value={selectedBuilderSupervisors}
          onChange={value => {
            const uniqValues = uniqBy(value, item => item.id);
            onBuilderSupervisorsChange?.(uniqValues);
          }}
          getOptionLabel={option => (option ? option.name : '')}
          variant="standard"
          label="Builder Supervisors"
          loading={loading}
          disabled={disabled}
        />
      </Box>
    );
  };

const useStyles = makeStyles({
  container: {
    display: 'flex',
    gap: '20px',
    width: '100%',
  },
});

export default SubDivisionSupervisorsSection;
